/**
 *
 * @param element the media
 * @param subStatusId sub status id to required to display the media
 * @returns whether or not a Tag has to be displayed according to the sub status
 * @returns
 */
function isSubStatusEligibleToDisplayVisualAlert(element, subStatusId) {
    return (element === null || element === void 0 ? void 0 : element.subStatusId) === subStatusId;
}

export { isSubStatusEligibleToDisplayVisualAlert };
//# sourceMappingURL=isSubStatusEligibleToDisplayVisualAlert.js.map
